const privateSlugs = [
  '/v1/payment-link/about-pl',
  '/v1/payment-link/before-starting',
  '/v1/payment-link/create-pl',
  '/v1/payment-link/create-additional-offer',
  '/v1/payment-link/get-pl',
  '/v1/payment-link/create-additional-plan',
  '/v1/payment-link/charge-by-value',
  '/v1/payment-link/charge-by-offer',
  '/tutorials/create-shopping-cart',
  '/v1/product/product-configuration',
  '/v1/account/get-account-info',
  '/tutorials/hotmart-authentication-create-credentials',
]

export function checkIsPrivateSlug(slug) {
  return privateSlugs.some(privateSlug => slug.toLowerCase().includes(privateSlug))
}

export function checkHasAuthorizationToResource(resources, slug) {
  const isPrivateSlug = checkIsPrivateSlug(slug)

  if (isPrivateSlug) {
    const hasAuthorization = resources.some(resource => slug.toLowerCase().includes(resource))

    return hasAuthorization
  }

  return true
}

export function checkHasAuthorizationToCategory(items, user, resources) {
  return items
    .map(({ slug }) => {
      return {
        slug,
        isFree: !checkIsPrivateSlug(slug),
        hasAuthorization: checkHasAuthorizationToResource(resources, slug),
      }
    })
    .map(({ isFree, hasAuthorization }) => (user && hasAuthorization && !isFree ? true : isFree))
    .some(hasPermission => hasPermission === true)
}
